import { minutesInHour } from 'date-fns/constants';

const NOT_AVAILABLE = 'N/A';

export function formatDuration(minutes: number | null | undefined): string {
  if (minutes == null || Number.isNaN(minutes)) return NOT_AVAILABLE;
  const wholeMinutes = Math.round(minutes);
  if (wholeMinutes < minutesInHour) return `${wholeMinutes} Min`;
  const hours = Math.floor(wholeMinutes / minutesInHour);
  const remainingMinutes = wholeMinutes % minutesInHour;
  return `${hours}h ${String(remainingMinutes).padStart(2, '0')}m`;
}
